import {
  Switch,
  Text,
  Textarea,
  Tooltip,
  UnstyledButton
} from "@marketplace/ui";
import { Controller, type UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { MdOutlineInfo } from "react-icons/md";

import type { AddProductFormSchema } from "../../hooks/schemas/use-add-product-form-schema";
import type { EditProductFormSchema } from "../../hooks/schemas/use-edit-product-form-schema";
import { ProductFormSectionCard } from "../product-form-section-card";

type ProductFormRecurringOrderProps = {
  formMethods: UseFormReturn<AddProductFormSchema | EditProductFormSchema>;
};

export const ProductFormRecurringOrder: React.FC<
  ProductFormRecurringOrderProps
> = ({ formMethods }) => {
  const { t: tProduct } = useTranslation("product");

  const {
    register,
    formState: { errors },
    control
  } = formMethods;

  return (
    <ProductFormSectionCard
      id="recurring-order"
      title={
        <div className="flex gap-1">
          <Text
            type="heading"
            size="l"
            weight="bold"
            className="text-fjord-grey-400"
          >
            {tProduct("addProductPage.form.legends.recurringOrder")}
          </Text>
          <ProductFormRecurringOrderTooltip />
        </div>
      }
      isCollapsible
      isOpen={formMethods.watch("isRecurring")}
      titleRightSection={
        <div className="flex items-center gap-2">
          <Text className="text-fjord-grey-300">
            {formMethods.watch("isRecurring")
              ? tProduct("addProductPage.recurringOrderActivated")
              : tProduct("addProductPage.recurringOrderDeactivated")}
          </Text>
          <Controller
            name="isRecurring"
            control={control}
            render={({ field }) => (
              <Switch checked={field.value} onChange={field.onChange} />
            )}
          />
        </div>
      }
    >
      <Textarea
        {...register("tncRecurring")}
        withAsterisk
        label={tProduct("addProductPage.form.labels.tncRecurring")}
        placeholder={tProduct("addProductPage.form.placeholders.tncRecurring")}
        classNames={{ input: "h-36" }}
        error={errors.tncRecurring?.message?.toString()}
      />
    </ProductFormSectionCard>
  );
};

export const ProductFormRecurringOrderTooltip = () => {
  const { t: tProduct } = useTranslation("product");

  return (
    <Tooltip
      label={tProduct("addProductPage.form.tooltips.recurringOrder")}
      position="top"
      withArrow
      multiline
      classNames={{
        tooltip:
          "!rounded-lg !bg-[#454545] p-[14px] w-[276px] !text-white !text-h-ss !font-semibold"
      }}
    >
      <UnstyledButton className="flex items-center justify-center">
        <MdOutlineInfo size={16} />
      </UnstyledButton>
    </Tooltip>
  );
};
